var map = {
	"./baterry_confirmation.png": "5250",
	"./commercial_invoice.png": "a543",
	"./dangerous_good.png": "db9d",
	"./labels_configuration.png": "8697",
	"./msds.png": "3e93",
	"./packing_slips.png": "32aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e6c8";